export const dosageValue = (d) => {
  const m = String(d || "").match(/\d+(?:\.\d+)?/);
  return m ? parseFloat(m[0]) : Infinity;
};

export const byDosage = (a, b) => dosageValue(a.dosage) - dosageValue(b.dosage) || a.price - b.price;

export const sizeLabel = (variants) =>
  variants.some((v) => /\d\s*ml\b/i.test(v.dosage || "")) ? "Size" : "Vial size";

// Group same-name products (different vial sizes) into one storefront listing.
export const groupByName = (products) => {
  const families = new Map();
  products.forEach((p) => {
    if (!families.has(p.name)) families.set(p.name, []);
    families.get(p.name).push(p);
  });
  return [...families.values()].map((list) => {
    const variants = [...list].sort(byDosage);
    const primary = variants.find((v) => v.in_stock) || variants[0];
    const prices = variants.map((v) => v.price);
    const ratingCount = variants.reduce((s, v) => s + (v.rating_count || 0), 0);
    const ratingSum = variants.reduce((s, v) => s + (v.rating_avg || 0) * (v.rating_count || 0), 0);
    return {
      id: primary.id,
      name: primary.name,
      category: primary.category,
      image_url: primary.image_url,
      dosage: variants.length === 1 ? primary.dosage : "",
      variants,
      featured: variants.some((v) => v.featured),
      in_stock: variants.some((v) => v.in_stock),
      price: Math.min(...prices),
      maxPrice: Math.max(...prices),
      rating_count: ratingCount,
      rating_avg: ratingCount ? Math.round((ratingSum / ratingCount) * 10) / 10 : 0,
    };
  });
};
